import { useCallback, useState } from 'react'

export const useD2DHandlers = () => {
  const [addDialogDeleteOpen, setAddDialogDeleteOpen] = useState(false)
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const [editStatusId, setEditStatusId] = useState<string | undefined>(
    undefined,
  )
  const [deleteStatusId, setDeleteStatusId] = useState<string | undefined>(
    undefined,
  )

  const handleOpenAddDialog = useCallback(() => {
    setEditStatusId(undefined)
    setAddDialogOpen(true)
  }, [])

  const handleOpenEditDialog = useCallback((id: string) => {
    setEditStatusId(id)
    setAddDialogOpen(true)
  }, [])

  const handleCloseDialog = useCallback(() => {
    setAddDialogOpen(false)
    setAddDialogDeleteOpen(false)
    setEditStatusId(undefined)
    setDeleteStatusId(undefined)
  }, [])

  const handleOpenDeleteDialog = useCallback((id: string) => {
    setDeleteStatusId(id)
    setAddDialogDeleteOpen(true)
  }, [])

  return {
    addDialogOpen,
    addDialogDeleteOpen,
    editStatusId,
    deleteStatusId,
    handleOpenAddDialog,
    handleOpenEditDialog,
    handleOpenDeleteDialog,
    handleCloseDialog,
  }
}
